var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRadar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ca1b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#537983"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.655,
    x2: 406.216,
    xlinkHref: "#lg1",
    y1: 107.655,
    y2: 406.216
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(-1 0 0 -1 -1601 -1613)",
    gradientUnits: "userSpaceOnUse",
    x1: -1989.713,
    x2: -1718.774,
    xlinkHref: "#lg1",
    y1: -2001.713,
    y2: -1730.774
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ade194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68ca44"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 146.959,
    x2: 337.356,
    xlinkHref: "#lg2",
    y1: 146.959,
    y2: 337.356
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68ca44",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47a920"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.701,
    x2: 389.304,
    xlinkHref: "#lg3",
    y1: 152.701,
    y2: 389.304
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.767,
    x2: 306.007,
    xlinkHref: "#lg3",
    y1: 213.767,
    y2: 306.007
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 423.105,
    x2: 375.783,
    xlinkHref: "#lg3",
    y1: 386.138,
    y2: 338.816
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 320.791,
    x2: 353.499,
    y1: 69.391,
    y2: 333.142
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ade194",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe177"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.61,
    x2: 378.294,
    y1: 339.087,
    y2: 326.56
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7701"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 343.722,
    x2: 389.61,
    y1: 306.665,
    y2: 352.553
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe860a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6914,
    stopColor: "#fc482b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb2b3a"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.547,
    x2: 254.429,
    xlinkHref: "#lg4",
    y1: 90.627,
    y2: -3.322
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 303.667,
    x2: 261.217,
    xlinkHref: "#lg4",
    y1: 484.983,
    y2: 457.843
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.187,
    x2: 284.001,
    xlinkHref: "#lg2",
    y1: 35.443,
    y2: 35.443
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.187,
    x2: 284.001,
    xlinkHref: "#lg2",
    y1: 474.557,
    y2: 474.557
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 460.404,
    x2: 460.404,
    xlinkHref: "#lg4",
    y1: 306.15,
    y2: 258.257
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 88.492,
    x2: 17.509,
    xlinkHref: "#lg4",
    y1: 335.408,
    y2: 274.342
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientTransform: "matrix(0 1 -1 0 -1086 532)",
    gradientUnits: "userSpaceOnUse",
    x1: -290.813,
    x2: -247.999,
    xlinkHref: "#lg2",
    y1: -1560.557,
    y2: -1560.557
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientTransform: "matrix(0 1 -1 0 -1086 532)",
    gradientUnits: "userSpaceOnUse",
    x1: -290.813,
    x2: -247.999,
    xlinkHref: "#lg2",
    y1: -1121.443,
    y2: -1121.443
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.42,
    x2: 70.226,
    xlinkHref: "#lg5",
    y1: 41.42,
    y2: 70.226
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 98.895,
    x2: 24.514,
    xlinkHref: "#lg4",
    y1: 100.351,
    y2: 25.971
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientTransform: "matrix(-1 0 0 -1 -1283.867 -219.867)",
    gradientUnits: "userSpaceOnUse",
    x1: -1752.448,
    x2: -1723.642,
    xlinkHref: "#lg5",
    y1: -688.448,
    y2: -659.642
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientTransform: "matrix(-1 0 0 -1 -1283.867 -219.867)",
    gradientUnits: "userSpaceOnUse",
    x1: -1694.973,
    x2: -1769.354,
    xlinkHref: "#lg4",
    y1: -629.516,
    y2: -703.897
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientTransform: "matrix(0 1 -1 0 -1086 532)",
    gradientUnits: "userSpaceOnUse",
    x1: -490.58,
    x2: -461.775,
    xlinkHref: "#lg5",
    y1: -1554.58,
    y2: -1525.775
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientTransform: "matrix(0 1 -1 0 -1086 532)",
    gradientUnits: "userSpaceOnUse",
    x1: -433.105,
    x2: -507.486,
    xlinkHref: "#lg4",
    y1: -1495.649,
    y2: -1570.029
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientTransform: "matrix(0 -1 1 0 -866.133 -751.867)",
    gradientUnits: "userSpaceOnUse",
    x1: -1220.448,
    x2: -1191.642,
    xlinkHref: "#lg5",
    y1: 907.552,
    y2: 936.358
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientTransform: "matrix(0 -1 1 0 -866.133 -751.867)",
    gradientUnits: "userSpaceOnUse",
    x1: -1162.973,
    x2: -1237.354,
    xlinkHref: "#lg4",
    y1: 966.484,
    y2: 892.103
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m255 31.842c-123.244 0-223.158 99.913-223.158 223.158s99.914 223.158 223.158 223.158 223.158-99.913 223.158-223.158-99.914-223.158-223.158-223.158zm0 378.785c-85.953 0-155.627-69.674-155.627-155.627s69.674-155.627 155.627-155.627 155.627 69.674 155.627 155.627-69.674 155.627-155.627 155.627z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 457.511c111.843 0 202.511-90.668 202.511-202.511s-90.668-202.511-202.511-202.511-202.511 90.668-202.511 202.511 90.668 202.511 202.511 202.511zm0-358.138c85.953 0 155.627 69.674 155.627 155.627s-69.674 155.627-155.627 155.627-155.627-69.674-155.627-155.627 69.674-155.627 155.627-155.627z",
    fill: "url(#SVGID_2_)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 255,
    fill: "url(#SVGID_3_)",
    r: 176.248
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 255,
    fill: "url(#SVGID_4_)",
    r: 130.484
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 255,
    fill: "url(#SVGID_5_)",
    r: 75.159
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410.659 337.715-26.691-26.691c-4.671-5.282-11.493-8.615-19.099-8.615-14.08 0-25.493 11.412-25.493 25.493 0 7.607 3.333 14.428 8.615 19.1l32.124 32.124c12.09-12.186 22.407-26.129 30.544-41.411z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m399.568 355.82c19.961-28.569 31.68-63.324 31.68-100.82 0-97.339-78.909-176.248-176.248-176.248v176.248z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m364.869 302.409c-9.751 0-18.218 5.475-22.506 13.516l57.206 39.894c4.046-5.791 7.747-11.839 11.086-18.109l-26.686-26.686c-4.672-5.282-11.493-8.615-19.1-8.615z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.563,
    cy: 326.505,
    fill: "url(#SVGID_9_)",
    r: 25.307
  }), /*#__PURE__*/React.createElement("path", {
    d: "m459.922 166.511h-115.65l-65.315-65.305-34.385-34.385v-34.73c3.455-.167 6.931-.251 10.428-.251 91.798.001 170.663 55.441 204.922 134.671z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.475 443.224v34.682c10.562-.488 20.93-1.716 31.059-3.623z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m255 70.885c-8.514 0-15.415-6.902-15.415-15.415v-40.055c0-8.513 6.901-15.415 15.415-15.415 8.514 0 15.415 6.902 15.415 15.415v40.055c0 8.514-6.901 15.415-15.415 15.415z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 510c-8.514 0-15.415-6.902-15.415-15.415v-40.055c0-8.514 6.902-15.415 15.415-15.415 8.514 0 15.415 6.902 15.415 15.415v40.055c0 8.513-6.901 15.415-15.415 15.415z",
    fill: "url(#SVGID_13_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m442.888 265.098 31.402 31.402c1.926-10.238 3.155-20.721 3.631-31.402z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.596 474.474c-13.163 2.422-26.734 3.685-40.596 3.685-123.239 0-223.159-99.919-223.159-223.159 0-2.286.031-4.572.104-6.837h37.339z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m439.115 255c0-8.514 6.902-15.415 15.415-15.415h40.055c8.514 0 15.415 6.902 15.415 15.415 0 8.514-6.902 15.415-15.415 15.415h-40.055c-8.514 0-15.415-6.901-15.415-15.415z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 255c0-8.514 6.902-15.415 15.415-15.415h40.055c8.514 0 15.415 6.902 15.415 15.415 0 8.514-6.902 15.415-15.415 15.415h-40.055c-8.513 0-15.415-6.901-15.415-15.415z",
    fill: "url(#SVGID_17_)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 255,
    fill: "#47a920",
    r: 25.435
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m57.532 22.845c-19.157 0-34.687 15.53-34.687 34.687v36.052c0 7.542 6.114 13.656 13.656 13.656 7.542 0 13.656-6.114 13.656-13.656v-22.296c0-9.051 7.337-16.387 16.387-16.387h27.039c7.542 0 13.656-6.114 13.656-13.656v-4.743c0-7.542-6.114-13.656-13.656-13.656h-36.051z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.782 39.114c-13.583 0-24.581 11.007-24.581 24.581v43.545h.3c7.542 0 13.656-6.114 13.656-13.656v-22.296c0-9.051 7.337-16.387 16.387-16.387h27.039c7.542 0 13.656-6.114 13.656-13.656v-2.13h-46.457z",
    fill: "url(#SVGID_19_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m452.468 487.155c19.157 0 34.687-15.53 34.687-34.687v-36.052c0-7.542-6.114-13.656-13.656-13.656-7.542 0-13.656 6.114-13.656 13.656v22.296c0 9.051-7.337 16.387-16.387 16.387h-27.039c-7.542 0-13.656 6.114-13.656 13.656v4.743c0 7.542 6.114 13.656 13.656 13.656h36.051z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m449.218 470.886c13.583 0 24.581-11.007 24.581-24.581v-43.545h-.3c-7.542 0-13.656 6.114-13.656 13.656v22.296c0 9.051-7.337 16.387-16.387 16.387h-27.039c-7.542 0-13.656 6.114-13.656 13.656v2.13h46.457z",
    fill: "url(#SVGID_21_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m487.155 57.532c0-19.157-15.53-34.687-34.687-34.687h-36.052c-7.542 0-13.656 6.114-13.656 13.656 0 7.542 6.114 13.656 13.656 13.656h22.296c9.051 0 16.387 7.337 16.387 16.387v27.039c0 7.542 6.114 13.656 13.656 13.656h4.743c7.542 0 13.656-6.114 13.656-13.656v-36.051z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m470.886 60.782c0-13.583-11.007-24.581-24.581-24.581h-43.545v.3c0 7.542 6.114 13.656 13.656 13.656h22.296c9.051 0 16.387 7.337 16.387 16.387v27.039c0 7.542 6.114 13.656 13.656 13.656h2.13v-46.457z",
    fill: "url(#SVGID_23_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m22.845 452.468c0 19.157 15.53 34.687 34.687 34.687h36.052c7.542 0 13.656-6.114 13.656-13.656 0-7.542-6.114-13.656-13.656-13.656h-22.296c-9.051 0-16.387-7.337-16.387-16.387v-27.039c0-7.542-6.114-13.656-13.656-13.656h-4.743c-7.542 0-13.656 6.114-13.656 13.656v36.051z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.114 449.218c0 13.583 11.007 24.581 24.581 24.581h43.545v-.3c0-7.542-6.114-13.656-13.656-13.656h-22.296c-9.051 0-16.387-7.337-16.387-16.387v-27.039c0-7.542-6.114-13.656-13.656-13.656h-2.13v46.457z",
    fill: "url(#SVGID_25_)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRadar);
export default __webpack_public_path__ + "static/media/icon-radar.38884259bbcc3e59b316840e66b06dd9.svg";
export { ForwardRef as ReactComponent };